import { Typography, TypographyProps } from '@mui/material'

const Title = ({ children, sx, ...props }: Omit<TypographyProps<'div'>, 'component' | 'variant'>) => (
  <Typography
    component="div"
    variant="h1"
    sx={[{ alignSelf: 'center', textAlign: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
    {...props}
  >
    {children}
  </Typography>
)

export default Title
